// Helpers puros para construir el set de valores ("data") de un slider del
// formulador. Se extraen de `formulator-slider.vue` para poder testear el
// comportamiento discreto/continuo del slider sin renderizar Vue.
//
// vue-slider-component ubica cada handle buscando el valor con `indexOf`
// dentro del array `data`. Por eso `data` y el `value` del slider DEBEN ser
// del mismo tipo (números): si `data` trae strings ('0.0', '2.0') y el value
// es numérico ([0, 2]), `indexOf` devuelve -1, el handle no se posiciona y el
// slider queda inoperable (bug de la urea en el extensor).

const ROUND_FACTOR = 10;
const SMALL_INTERVAL = 0.1;
const SMALL_MIN = 0.5;

function round(number) {
  return Math.round(parseFloat(number) * ROUND_FACTOR) / ROUND_FACTOR;
}

function isSmallInterval(min, interval) {
  return interval <= SMALL_INTERVAL && min < SMALL_MIN;
}

function reverseValues(min, max, interval) {
  const values = [];
  for (let i = min; i <= max; i += interval) {
    values.push(i > 0 ? round(i) : round(-i));
  }

  return values;
}

// Set de valores [0, 0.5, 0.6, ... max] que se salta los valores pequeños
// (0.1 - 0.4). Devuelve NÚMEROS para que coincidan con el value numérico del
// slider y `indexOf` los encuentre.
function skipSmallValues(max, interval) {
  const values = [0];
  for (let i = SMALL_MIN; round(i) <= max; i += interval) {
    values.push(round(i));
  }

  return values;
}

// Devuelve el array `data` (set discreto de valores) del slider, o null para
// que el slider opere en modo continuo (min/max/interval).
//
// `forceSkip` (urea): el slider SIEMPRE usa el set discreto que se salta los
// valores pequeños (0 -> 0.5, en pasos de 0.1), incluso en modo rango. Como el
// set son NÚMEROS que coinciden con el value numérico ([0, 2]), `indexOf`
// posiciona ambos handles y el slider queda operable.
//
// Para el resto de los sliders de rango (value = [min, max]) se usa el modo
// continuo (min/max/interval): el modo discreto rompe el posicionamiento de los
// dos handles.
function sliderData({ min, max, interval, reverse = false, isRange = false, forceSkip = false }) {
  if (forceSkip) return skipSmallValues(max, interval);
  if (isRange) return null;
  if (reverse) return reverseValues(min, max, interval);
  if (isSmallInterval(min, interval)) return skipSmallValues(max, interval);

  return null;
}

// Ajusta un valor al set permitido de la urea (0 o múltiplos de 0.1 desde 0.5).
// Evita handles "congelados" si la configuración trae un valor fuera de grilla.
function snapToSkipValue(value, max) {
  const rounded = round(value);
  if (rounded <= 0) return 0;
  if (rounded < SMALL_MIN) return SMALL_MIN;
  if (rounded > round(max)) return round(max);

  return rounded;
}

module.exports = {
  round,
  isSmallInterval,
  reverseValues,
  skipSmallValues,
  sliderData,
  snapToSkipValue,
};
